import { Component } from "react";
import { renderRoutes } from "react-router-config";

export default class App extends Component {
  render() {
    return renderRoutes(this.props.route.routes);
  }
}



// WEBPACK FOOTER //
// ./src/containers/App/index.js